import React, { useState } from 'react'

import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton, ListItem, ListItemSecondaryAction, ListItemText } from '@mui/material'
import { format } from 'date-fns'

import { ConfirmModal } from 'components/_base'

type CampaignNoteProps = {
  campaignId: string
  deleteCampaignNote: (...args: any[]) => any
  note: any
}

const CampaignNote = ({ campaignId, deleteCampaignNote, note }: CampaignNoteProps) => {
  const [open, setOpen] = useState(false)

  const { createdAt, user, text } = note
  const userName = `${user.firstName || ''} ${user.lastName}`
  const formattedDate = createdAt ? format(new Date(createdAt), 'dd-MM-yyyy HH:mm:ss') : ''
  const secondaryText = [userName, formattedDate].filter(x => x).join(', ')

  const handleNoteDelete = () => {
    deleteCampaignNote(campaignId, note.id)
    setOpen(false)
  }

  return (
    <ListItem sx={{ pl: 0 }}>
      <ListItemText primary={text} secondary={secondaryText} />
      <ListItemSecondaryAction>
        <IconButton aria-label="Delete note" onClick={() => setOpen(true)} size="large">
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
      <ConfirmModal
        onClose={() => setOpen(false)}
        onConfirm={handleNoteDelete}
        open={open}
        title="Do you want to delete this note?"
      />
    </ListItem>
  )
}

export default CampaignNote
